import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, ChevronRight, RotateCw } from "lucide-react";
import { Create_Api_Formdata } from "../API_URL";
import { toast } from "react-toastify";

const ServiceNowLeadForm = () => {
    const [FirstName, setFirstName] = useState("");
    const [Email, setEmail] = useState("");
    const [Number, setNumber] = useState("");
    const [Company, setCompany] = useState("");
    const [Enquiry, setEnquiry] = useState("");
    const [Message, setMessage] = useState("");

    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [agreed, setAgreed] = useState(false);

    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [captchaValue, setCaptchaValue] = useState("");
    const [captchaError, setCaptchaError] = useState("");

    const generateCaptcha = () => {
        const a = Math.floor(Math.random() * 9) + 1;
        const b = Math.floor(Math.random() * 9) + 1;

        setNum1(a);
        setNum2(b);
        setCaptchaValue("");
        setCaptchaError("");
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const CreateContactUs = async (e) => {
        if (e) e.preventDefault();

        if (parseInt(captchaValue) !== num1 + num2) {
            setCaptchaError("Captcha is incorrect");
            return;
        }

        setCaptchaError("");

        let newErrors = {};

        if (!FirstName.trim()) {
            newErrors.FirstName = "Full Name is required";
        }

        if (!Email.trim()) {
            newErrors.Email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Email)) {
            newErrors.Email = "Please enter a valid email address";
        }

        if (!Number.trim()) {
            newErrors.Number = "Phone number is required";
        } else if (!/^\d{10}$/.test(Number)) {
            newErrors.Number =
                "Please enter a valid 10-digit phone number";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const formData = new FormData();

        formData.append("FirstName", FirstName);
        formData.append("Email", Email);
        formData.append("PhoneNumber", Number);
        formData.append("Company", Company);
        formData.append("Enquiry", Enquiry);
        formData.append("Message", Message);

        try {
            setIsLoading(true);

            const response = await Create_Api_Formdata(
                "api/admin/CreateContactus",
                formData
            );

            if (response?.data) {
                setSuccessMessage(
                    "Your message has been received. We’ll get back to you as soon as possible."
                );

                setFirstName("");
                setEmail("");
                setNumber("");
                setCompany("");
                setEnquiry("");
                setMessage("");
                setAgreed(false);
                setErrors({});

                generateCaptcha();
            } else {
                toast.error(
                    response?.message || "Failed to upload requirement"
                );
            }
        } catch (error) {
            console.error("Error uploading requirement:", error);

            toast.error(
                error?.response?.message ||
                "Failed to upload requirement"
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="w-full bg-[#FFFFFF] py-[20px]  mt-[50px]">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

                <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start justify-between">

                    {/* LEFT CONTENT */}

                    <div className="w-full relative max-w-[560px]">

                        <div className="lg:pb-[100px]">

                            <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.2] mb-4">
                                Reach Out to Us
                            </h2>

                            <p className="font-graphik text-[14px] sm:text-[16px] text-[#49577A] font-[500] leading-[1.6]">
                                Fill up the form below and we'll be in touch
                            </p>

                        </div>

                        <div className="opacity-100 rotate-[160deg] pointer-events-none">
                            <FlowingMeshCanvasAlt />
                        </div>

                    </div>

                    {/* RIGHT FORM */}

                    <div className="w-full max-w-[705px] bg-white">

                        <form
                            onSubmit={CreateContactUs}
                            className="flex flex-col gap-5"
                        >

                            {/* NAME + EMAIL */}

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">

                                <div className="relative w-full">

                                    <input
                                        type="text"
                                        placeholder="Full Name *"
                                        value={FirstName}
                                        onChange={(e) => {
                                            setFirstName(e.target.value);
                                            setErrors((prev) => ({
                                                ...prev,
                                                FirstName: ""
                                            }));
                                        }}
                                        className="w-full h-[34px] px-4 border border-[#D9E2EC] font-graphik text-[14px] text-[#01386A] placeholder-[#94A3B8] focus:outline-none focus:border-[#ED6800] transition-colors"
                                    />

                                    {errors?.FirstName && (
                                        <span className="text-red-500 text-xs absolute -bottom-4 left-0">
                                            {errors.FirstName}
                                        </span>
                                    )}

                                </div>

                                <div className="relative w-full">

                                    <input
                                        type="email"
                                        placeholder="Email *"
                                        value={Email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            setErrors((prev) => ({
                                                ...prev,
                                                Email: ""
                                            }));
                                        }}
                                        className="w-full h-[34px] px-4 border border-[#D9E2EC] font-graphik text-[14px] text-[#01386A] placeholder-[#94A3B8] focus:outline-none focus:border-[#ED6800] transition-colors"
                                    />

                                    {errors?.Email && (
                                        <span className="text-red-500 text-xs absolute -bottom-4 left-0">
                                            {errors.Email}
                                        </span>
                                    )}

                                </div>

                            </div>

                            {/* PHONE + COMPANY */}

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">

                                <div className="relative w-full">

                                    <div className="flex items-center h-[34px] px-3 border border-[#D9E2EC] bg-white">

                                        <span className="text-[18px] mr-2">
                                            🇮🇳
                                        </span>

                                        <span className="font-graphik text-[14px] text-[#01386A] font-medium mr-2">
                                            +91
                                        </span>

                                        <ChevronDown
                                            size={14}
                                            className="text-[#94A3B8] mr-2"
                                        />

                                        <input
                                            type="tel"
                                            placeholder="00000 00000"
                                            value={Number}
                                            onChange={(e) => {
                                                setNumber(
                                                    e.target.value.replace(/\D/g, "").slice(0, 10)
                                                );
                                                setErrors((prev) => ({
                                                    ...prev,
                                                    Number: ""
                                                }));
                                            }}
                                            className="w-full h-full border-none font-graphik text-[14px] text-[#01386A] placeholder-[#94A3B8] outline-none ring-0 shadow-none focus:outline-none focus:ring-0 focus:shadow-none"
                                        />

                                    </div>

                                    {errors?.Number && (
                                        <span className="text-red-500 text-xs absolute -bottom-4 left-0">
                                            {errors.Number}
                                        </span>
                                    )}

                                </div>

                                <input
                                    type="text"
                                    placeholder="Company *"
                                    value={Company}
                                    onChange={(e) => setCompany(e.target.value)}
                                    className="w-full h-[34px] px-4 border border-[#D9E2EC] font-graphik text-[14px] text-[#01386A] placeholder-[#94A3B8] focus:outline-none focus:border-[#ED6800] transition-colors"
                                />

                            </div>

                            {/* ENQUIRY TYPE */}

                            <div className="relative">

                                <select
                                    value={Enquiry}
                                    onChange={(e) => setEnquiry(e.target.value)}
                                    className={`w-full h-[34px] pl-4 pr-10 appearance-none border border-[#D9E2EC] font-graphik text-[14px] ${Enquiry ? "text-[#01386A]" : "text-[#94A3B8]"} focus:outline-none focus:border-[#ED6800] transition-colors bg-white cursor-pointer`}
                                >

                                    <option value="" disabled hidden>
                                        Select Enquiry Type *
                                    </option>

                                    <option value="cloud">
                                        Cloud Engineering & Architecture
                                    </option>

                                    <option value="gcc">
                                        Global Capability Center (GCC)
                                    </option>

                                    <option value="automation">
                                        Automation & Agentic AI
                                    </option>

                                    <option value="embedded">
                                        Embedded Engineering
                                    </option>

                                    <option value="staff">
                                        Staff Augmentation
                                    </option>

                                    <option value="service">
                                        Service Request
                                    </option>

                                    <option value="job">
                                        Job Application
                                    </option>

                                    <option value="partnership">
                                        Partnership
                                    </option>

                                    <option value="product">
                                        Product
                                    </option>

                                    <option value="other">
                                        Other
                                    </option>

                                </select>

                                <ChevronDown
                                    size={16}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-[#94A3B8] pointer-events-none"
                                />

                            </div>

                            {/* MESSAGE */}

                            <div>

                                <textarea
                                    rows={4}
                                    placeholder="Message *"
                                    value={Message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    className="w-full p-4 border border-[#D9E2EC] font-graphik text-[14px] text-[#01386A] placeholder-[#94A3B8] focus:outline-none focus:border-[#ED6800] transition-colors resize-none"
                                />

                            </div>

                            {/* CAPTCHA */}

                            <div>

                                <div className="flex items-center gap-[15px]">

                                    <div className="text-black text-[18px] font-[600] select-none font-graphik">
                                        {num1} + {num2} =
                                    </div>

                                    <input
                                        type="text"
                                        placeholder="Captcha *"
                                        value={captchaValue}
                                        onChange={(e) => {
                                            setCaptchaValue(
                                                e.target.value.replace(/\D/g, "")
                                            );
                                            setCaptchaError("");
                                        }}
                                        className="w-[120px] h-[34px] px-3 border border-[#D9E2EC] font-graphik text-[14px] text-[#01386A] placeholder-[#94A3B8] focus:outline-none focus:border-[#ED6800] transition-colors"
                                    />

                                    <button
                                        type="button"
                                        onClick={generateCaptcha}
                                        className="text-[#ED6800] text-[14px] underline font-medium flex items-center gap-1.5 group cursor-pointer"
                                    >
                                        <RotateCw
                                            size={14}
                                            className="transition-transform duration-300 group-hover:rotate-180"
                                        />
                                    </button>

                                </div>

                                {captchaError && (
                                    <span className="text-red-500 text-xs block mt-1">
                                        {captchaError}
                                    </span>
                                )}

                            </div>

                            {/* PRIVACY POLICY */}

                            <label className="flex items-center gap-3 cursor-pointer select-none">

                                <input
                                    type="checkbox"
                                    checked={agreed}
                                    onChange={(e) => setAgreed(e.target.checked)}
                                    className="w-4 h-4 rounded border-[#D9E2EC] text-[#ED6800] focus:ring-[#ED6800]"
                                />

                                <span className="font-graphik text-[14px] font-[500] text-[#6B7C96]">
                                    I agree to Mobikode’s privacy policy
                                </span>

                            </label>

                            {/* SUCCESS MESSAGE */}

                            {successMessage && (
                                <div className="p-3 bg-green-50 border border-green-300 text-green-700 text-sm font-graphik">
                                    {successMessage}
                                </div>
                            )}

                            {/* SUBMIT BUTTON */}

                            <div className="pt-2">

                                <button
                                    type="submit"
                                    disabled={IsLoading}
                                    className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-[#ED6800] text-[#ED6800] hover:bg-[#ED6800] hover:text-white font-graphik font-[500] lg:text-[16px] text-[14px] transition-all duration-300 disabled:opacity-60 cursor-pointer"
                                >

                                    <span>
                                        {IsLoading ? "Please Wait" : "Submit"}
                                    </span>

                                    <ChevronRight size={16} />

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>
        </section>
    );
};


/* FLOWING MESH ANIMATION */

const FlowingMeshCanvasAlt = () => {

    const canvasRef = useRef(null);

    useEffect(() => {

        const canvas = canvasRef.current;

        if (!canvas) return;

        const ctx = canvas.getContext("2d");

        let animationFrameId;
        let time = 0;

        const resizeCanvas = () => {
            const rect = canvas.getBoundingClientRect();

            const dpr = window.devicePixelRatio || 1;

            canvas.width = rect.width * dpr;
            canvas.height = rect.height * dpr;

            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };

        window.addEventListener("resize", resizeCanvas);

        resizeCanvas();

        const draw = () => {

            const width = canvas.width / (window.devicePixelRatio || 1);
            const height = canvas.height / (window.devicePixelRatio || 1);

            ctx.clearRect(0, 0, width, height);

            const lines = 30;
            const amplitude = 90;
            const frequency = 0.002;
            const speed = 0.0025;

            ctx.lineWidth = 0.8;

            for (let i = 0; i < lines; i++) {

                ctx.beginPath();

                const alpha = 0.1 + (i / lines) * 0.25;

                ctx.strokeStyle = `hsla(217, 54%, 24%, ${alpha})`;

                for (let x = 0; x <= width; x += 30) {

                    const yOffset = height / 1.4;

                    const y1 = Math.sin(
                        x * frequency - time + i * 0.05
                    ) * amplitude;

                    const y2 = Math.sin(
                        x * frequency * 0.5 - time * 0.5
                    ) * (amplitude * 0.5);

                    const tilt = (x / width) * -150;

                    ctx.lineTo(
                        x,
                        yOffset + y1 + y2 + tilt + (i * 4)
                    );

                }

                ctx.stroke();

            }

            time += speed;

            animationFrameId = requestAnimationFrame(draw);

        };

        draw();

        return () => {
            window.removeEventListener("resize", resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };

    }, []);

    return (
        <canvas
            ref={canvasRef}
            className="w-full h-full"
        />
    );
};

export default ServiceNowLeadForm;